export const COMBAT_TYPE = {
  MELEE: 'MELEE',
  SHOOTING: 'SHOOTING',
  TRAP: 'TRAP'
}

export const FORTRESS_MELEE_DAMAGE_RATION = 3;